<template>
	<inertia-head title="Events" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Events</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">Events Management List</h2>
				</div>
			</div>
		</div>
	</div>

	<div class="content">
		<h5>
			<div class="form-check form-switch form-check-inline">
				<input
					class="form-check-input"
					type="checkbox"
					:value="form.filter"
					:id="form.filter"
					name="filter"
					:checked="form.filter"
					@change="changeCategory()"
				/>
				<label class="form-check-label fw-semibold" for="filter">
					{{ form.filter==0 ? 'PAST EVENT' : 'UPCOMING' }}
				</label>
			</div>
		</h5>
		<div class="block border-bottom">
			<div class="block-content">
				<form @submit.prevent="searchRecord">
					<div class="row">
						<div class="col-md-3 mb-4">
							<div class="input-group">
								<span class="input-group-text">Type</span>
								<select v-model="form.type" class="form-select">
									<option value="">ALL</option>
									<option value="1">LIVE</option>
									<option value="0">NOT LIVE</option>
								</select>
							</div>
						</div>
						<div class="col-md-3 mb-4">
							<div class="input-group">
								<span class="input-group-text">Category</span>
								<select v-model="form.category" class="form-select">
									<option value="">ALL</option>
									<option value="seminars">Seminars</option>
									<option value="trc_coffee">TRC Coffee</option>
								</select>
							</div>
						</div>
						<div class="col-md-3 mb-4">
							<div class="form-group">
								<input v-model="form.search" type="text" id="search" name="search" class="form-control" placeholder="Search" />
							</div>
						</div>
						<div class="col space-x-1 mb-4">
							<button
								type="submit"
								class="btn btn-secondary"
								:disabled="!form.isDirty || form.processing"
							>
								<i class="fa fa-search me-1"></i>Display
							</button>
							<button
								@click="addEvent"
								type="button"
								class="btn btn-info float-end"
							>
								<i class="fa fa-plus me-1"></i>Add
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<pagination :collections="events" />
		<div v-for="(event,v_index) in events.data" class="block mb-1" :class="{'border-start border-danger border-5':event.is_live==1}">
			<div class="block-content block-content-full">
				<div class="row">
					<div class="col-md-3">
						<img :src="event.event_img_url??'/media/images/event_image.jpeg'" style="width:100%"/>
					</div>
					<div class="col-md-9">
						<p class="m-0"><span class="fw-bold">{{event.title}}</span>
							<span v-if="event.is_featured==1" class="badge bg-warning fw-normal fs-xs ms-2">Featured</span>
							<span v-if="event.is_live==1" class="badge bg-danger fw-normal ms-2"><i class="fa fa-video fs-xs me-1"></i>LIVE</span>
						</p>
						<p class="m-0 text-elegance fs-xs fw-semibold fst-italic"><span>Membership Level: {{(event.membership_level)}}</span></p>
						<div class="fs-sm fw-normal text-muted mb-2">
							<span class="me-3">
								<i class="fa fa-fw fa-calendar-alt opacity-50 me-1"></i>
								{{ event.start_display }}
							</span>

							<div class="form-check form-switch form-check-inline">
								<input
									class="form-check-input"
									type="checkbox"
									:value="event.is_active"
									:id="event.id"
									name="example-switch-inline1"
									:checked="event.is_active"
									@change="toggleStatus(event.event_id,event.is_active)"
								/>
								<label class="form-check-label fw-semibold" :for="event.event_id">
									{{ event.is_active ? 'ACTIVE' : 'IN-ACTIVE' }}
								</label>
							</div>
							<div>
								<span class="badge bg-secondary">{{(event.category).replace('_',' ').toUpperCase()}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="block-content block-content-full block-content-sm bg-body-light fs-sm space-x-1">
				<button @click="updateEvent(v_index)" type="button" class="btn btn-outline-info btn-sm"><i class="fa fa-edit me-1"></i>Edit</button>
				<button @click="selectDeleteEvent(event.event_id)" type="button" class="btn btn-outline-danger btn-sm"><i class="fa fa-times me-1"></i>Delete</button>
			</div>
		</div>
		<div v-if="events.data.length==0" class="block mb-1">
			<div class="block-content block-content-full">
				<h1 class="text-center text-danger">No Event Found</h1>
			</div>
		</div>
		<div class="mt-3">
			<pagination :collections="events" />
		</div>
	</div>


	<modal ref="deleteModal" size="modal-md">
		<template #title>
			Delete Confirmation
		</template>
		<template #body>
			<div class="mb-4">
				<p class="h5">Are you sure, you want to delete this details?</p>
			</div>
		</template>
		<template #footer>
			<button @click="confirmDeleteEvent" type="button" class="btn btn-sm btn-danger"><i class="fa fa-trash"></i> Delete</button>
			<button type="button" class="btn btn-sm btn-secondary" @click="deleteModal.toggleModal()"><i class="fa fa-times"></i> Cancel</button>
		</template>
	</modal>

	<AddUpdateEventModal
			key="EventModal"
			ref="addUpdateEventModal"
			:category="category"
			:live_exist="live_exist"
		/>

</template>

<script>
	import { onMounted, watch, ref, reactive } from 'vue';
	import { useForm } from '@inertiajs/inertia-vue3';
	import AuthLayout from '../../Layouts/AuthLayout';
	import { createToaster } from '@meforma/vue-toaster';
	import { Inertia } from '@inertiajs/inertia';
	import AddUpdateEventModal from '../../Components/Admin/AddUpdateEventModal'

	export default{
		layout: AuthLayout,
		props: {
			events				: Object,
			filter				: String,
			type				: String,
			category			: String,
			search				: String,
			live_exist			: Number,
			api_response 		: Object
		},
		components:{AddUpdateEventModal},
		setup(props){

			const deleteModal = ref(null);

			const selected_event_id = ref(null);

			const toast = createToaster();

			const action = ref('add');

			const form = useForm({
							filter 		: props.filter,
							type 		: props.type,
							category 	: props.category,
							search 		: props.search,
							is_active 	: 0,
						})

			const addUpdateEventModal = ref(null);

			const changeCategory = () => {

				if(form.filter==1)
				{
					form.filter=0;
				}else
				{
					form.filter=1;
				}

				Inertia.get(route('admin.events',{
						filter 		: form.filter,
						type 		: form.type,
						category 	: form.category,
						search 		: form.search
					})
				)
			}


			const searchRecord = () => {

				Inertia.get(route('admin.events',{
						filter 		: props.filter,
						type 		: form.type,
						category 	: form.category,
						search 		: form.search
					})
				)
			}


			const toggleStatus = (_event_id,is_active)=>{
				action.value = "update";
				form.is_active = (is_active==1) ? 0 : 1;
				form.put('events/status/'+_event_id, {
					preserveState: true,
					preserveScroll: true,
					only:['events,api_response'],
				})
			}

			const addEvent = ()=>{

								action.value = "add";
								addUpdateEventModal.value.setEventContent(action.value,null);
								addUpdateEventModal.value.toggleModal();
							}

			const updateEvent = (_index)=>{

									action.value = "update";

									addUpdateEventModal.value.setEventContent(action.value,props.events.data[_index]);

									addUpdateEventModal.value.toggleModal();
								}

			const selectDeleteEvent = (_event_id)=>{
										selected_event_id.value = _event_id;
										deleteModal.value.toggleModal();
									}

			const confirmDeleteEvent = ()=>{
										deleteEvent(selected_event_id.value);
									}

			const deleteEvent = (_event_id) => {
									action.value = "delete";
									Inertia.delete('events/'+_event_id,
									{
										preserveState: true,
										preserveScroll: true,
										only:['events','api_response'],
										onSuccess:()=> {
											selected_event_id.value = null;
											deleteModal.value.toggleModal();
										}
									})
								}

			watch(()=>props.api_response, (value) => {
			
				if(value!=null)
				{
					var action_msg = action.value=='add'?'added':(action.value=='update'?'updated':'deleted'); 

					if(value.result=="success")
					{
						toast.show("Successfully "+action_msg, { type: value.result});
					}else
					{
						toast.show("Failed to process", { type: "error"});
					}
				}
			})

			return{
				selected_event_id,
				selectDeleteEvent,
				deleteModal,
				confirmDeleteEvent,
				toast,
				action,
				form,
				toggleStatus,
				changeCategory,
				addUpdateEventModal,
				searchRecord,
				addEvent,
				updateEvent,
				deleteEvent
			}

		}
	}

</script>